<template>
  <div class="live-training-individual-page">
    <Training :info="info">
      <VideoPlayer
        v-if="info.video && videoJSLoaded" slot="player" :video-id="info.video"
        class="video-player"
      />
      <GetAccess
        slot="get-access" :features="features" button-text="Sign Up"
        button-link="/live-trainings/signup/"
      />
      <div v-if="info.trainingSlider && info.trainingSlider.length" slot="slider" class="section trainings-slider">
        <div class="container">
          <div class="col-10 offset-1">
            <Slider :disabled="info.trainingSlider.length <= 3" dark>
              <h3 slot="heading">
                Other Live Training
              </h3>
              <Card
                v-for="(training, id) in info.trainingSlider"
                slot="slide" :key="id"
                :training="training"
                :to="`/live-trainings/${training.slug}/`"
                heading="h4"
                dark
              />
            </Slider>
          </div>
        </div>
      </div>
    </Training>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Training from '@itbpbg/lms-components/src/Business/LiveTrainings/Training';
import Card from '@itbpbg/lms-components/src/Business/LiveTrainings/Card';
import VideoPlayer from '@itbpbg/lms-components/src/components/VideoPlayer.vue';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import GetAccess from '../../components/Business/GetAccess';

export default {
  components: {
    Training,
    Card,
    VideoPlayer,
    Slider,
    GetAccess,
  },
  mixins: [global],
  // middleware({ redirect }) {
  //   redirect('/');
  // },
  async asyncData({
    $axios, route, $config, error,
  }) {
    const info = await $axios.$get(`/business/live-trainings/${route.params.slug}/?slider=true`).catch(() => false);

    if (!info.title || $config.platform === 'fa') {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    info.fullPath = `${$config.siteUrl}${route.fullPath}`;
    return { info };
  },
  data() {
    return {
      videoJSLoaded: false,
      features: [
        { name: 'Renowned Industry Experts' },
        { name: 'Community-Fostered Active Learning' },
        { name: 'Training for All Skill Levels and Expertise' },
        { name: 'Certificates of Achievement' },
      ],
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      {
        key: 'WebPage',
        values: {
          ...this.info,
          metaTitle: this.info.title,
        },
      },
      {
        key: 'Person',
        values: {
          name: this.info.author,
          url: `${this.$config.siteUrl}${this.$route.fullPath}`,
          image: {
            '@type': 'ImageObject',
            url: `${this.$config.imagesUrl}/team/${this.info.image}`,
            caption: `${this.info.author}'s image`,
          },
        },
      },
    ]);

    return {
      titleTemplate: `${this.info.title}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps({ ...this.info }),
      script: [
        linkedData,
        { src: 'https://players.brightcove.net/6258000438001/FHDad0Z7G_default/index.min.js', async: true },
      ],
    };
  },
  async mounted() {
    await this.$pollValue(() => typeof videojs !== 'undefined');
    this.videoJSLoaded = true;
  },
  methods: {
  },
};
</script>

<style lang="scss">
.live-training-individual-page {
  .training-page {
    .trainings-slider {
      background-color: var(--main-dark);
      color: var(--main-light);

      .slider-container {
        .row {
          margin-left: -23px;
          margin-right: -23px;

          .col {
            padding-left: 23px;
            padding-right: 23px;
          }
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .live-training-individual-page {
    .training-page {
      .trainings-slider {
        .slider-container {
          .slider-header {
            flex-direction: column;

            .controls {
              display: flex;
            }
          }

          .training-card {
            .image-holder {
              height: 195px;
            }
          }

          .dots {
            display: none;
          }
        }
      }
    }
  }
}
</style>
